import plMessages from './messages-pl';

angular
  .module('blocks.i18n')
  .service('messagesPlService', messagesPlService);

function messagesPlService() {
  this.messages = plMessages;
}
